(function FranchiseChargeForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FranchiseCharge',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.balances').click(function countItUp() {
			getTotal();
			buidIds();
		});

		$('.balances-check-all').click(function checkUncheckAll() {
			if ($(this).prop('checked') === true) {
				$('.balances').each(function checkEm() {
					$(this).prop('checked', true);
				});
			} else {
				$('.balances').each(function checkEm() {
					$(this).prop('checked', false);
				});
			}

			getTotal();
			buidIds();
		});

		$('#franchisecharge-franchise_credit_card').change(function showHideNew() {
			if ($(this).val() === 'other') {
				$('.new-card').each(function showFields() {
					$(this).removeClass('hidden');
				});
			} else {
				$('.new-card').each(function showFields() {
					$(this).addClass('hidden');
				});
			}
		});
	};

	function getTotal()
	{
		var total = 0;

		$('.balances').each(function calculateAll() {
			if ($(this).prop('checked') === true) {
				total += ($(this).data("amount") + $(this).data("cc-fee"));
			}
		});

		$('#franchisecharge-amount').val(accounting.formatNumber(total, 2, ''));
	}

	function buidIds()
	{
		var ids = '';

		$('.balances').each(function calculateAll() {
			if ($(this).prop('checked') === true) {
				ids += $(this).data("id") + "^" + $(this).data("amount") + "^" + $(this).data("original-amount") + "^" + $(this).data("cc-fee") + "|";
			}
		});

		ids = ids.slice(0, -1);

		$('#franchisecharge-charges').val(ids);
	}

}(jQuery, window.Adzuki || {}));
